import { Box } from "@mui/material";
import {
  HeadingText,
  ParagraphText,
  UBAppModal,
  UBButton,
} from "../../../../Libraries";
import { useContext } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import {
  CheckmarkGreenIcon,
  LogoRupin,
  LogoRupinNew,
  ModalIcon,
  TickIcon,
} from "../../../../assets/icons/icon";
import { ReactComponent as LogoUdhaar } from "../../../../assets/icons/Logo_Udhaar.svg";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const MIGRATION_FEATURES = [
  "migration_account_safe",
  "migration_data_secure",
  "migration_transaction_intact",
  "migration_business_records_unchanged",
];

const UdhaarMigrationModal = ({
  isOpen,
  handleClose,
  onContinue,
  className = "",
}) => {
  const [I18n] = useContext(LanguageContext);

  const handleContinue = () => {
    triggerLogEvent(analytics, "udhaar_migration_continue");
    onContinue?.();
  };

  return (
    <UBAppModal
      id="udhaar_migration_modal"
      open={isOpen}
      disableRestoreFocus
      className={`${styles.udhaarMigrationModal} ${className}`}
      header={{
        handleClose,
        CustomHeader: <></>,
      }}
    >
      <Box className={styles.modalLayout}>
        <Box className={styles.graphicPanel} aria-hidden="true">

          <Box className={styles.logoTransition}>
            <Box className={styles.udhaarLogoCircle}>
              <LogoUdhaar className={styles.udhaarLogoMark} />
            </Box>
            <span className={styles.transitionArrow} aria-hidden="true">
              <ModalIcon />
            </span>
            <Box className={styles.rupinLogoCircle}>
              <LogoRupinNew className={styles.rupinLogo} />
            </Box>
          </Box>
        </Box>

        <Box className={styles.contentPanel}>
          <HeadingText as="h2" className={styles.title}>
            {I18n.udhaar_book_is_now_rupin}
          </HeadingText>

          <ParagraphText className={styles.subtitle}>
            {I18n.migration_upgrade_subtitle}
          </ParagraphText>

          <Box className={styles.featureList}>
            {MIGRATION_FEATURES.map((key) => (
              <Box key={key} className={styles.featureItem}>
                <TickIcon className={styles.featureIcon} />
                <ParagraphText className={styles.featureText}>
                  {I18n[key]}
                </ParagraphText>
              </Box>
            ))}
          </Box>

          <Box className={styles.footerAction}>
            <UBButton
              id="udhaar_migration_continue"
              title={I18n.continue_to_rupin}
              className={styles.continueButton}
              onClick={handleContinue}
            />
          </Box>
        </Box>
      </Box>
    </UBAppModal>
  );
};

export default UdhaarMigrationModal;
